<template>
	<div id="map-optimization" class="map-custom-container">
		<vs-popup title="Google Street View" :active.sync="popupStreeViewActive" style="z-index: 99999">
			<div id="gpanoramaoptimization" class="street-vien-container-optimization"></div>
		</vs-popup>
	</div>
</template>

<script>
import {MapFeatures} from "@/plugins/mapFeatures";
import Utils from "@/helpers/Utils";
import Uber from "./themes/uber";
import moduleMap from "@/store/map/moduleMap.js";
import streetviewImg from "@/assets/images/maps/google-street-view-icon-5.png";
import {GoogleMapsOverlay} from "@deck.gl/google-maps";
import {IconLayer} from "@deck.gl/layers";

export default {
	name: "OptimizationMap",
	props: {
		name: {
			type: String,
			required: true,
			default: "themap",
		},
		latitude: {
			type: Number,
			required: false,
			default: 4.686699,
		},
		longitude: {
			type: Number,
			required: false,
			default: -74.0837187,
		},
		zoom: {
			type: String,
			required: false,
			default: "12",
		},
		theme: {
			type: String,
			required: false,
			default: null,
		},
		streetview: {
			type: String,
			required: false,
			default: "false",
		},
		calledFrom: {
			type: String,
			requeride: false,
			default: "maps",
		},
		cartodbId: {
			type: Number,
			default: 0,
		},
		getCallbackClick: {
			type: Function,
			default: () => {},
		},
		getCoordinatesDrag: {
			type: Function,
			default: () => {},
		},
		changeCursorEnable: {
			type: Boolean,
			default: false,
		},
		visitPointList: {
			type: Array,
			default: () => [],
		},
		typeService: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			map: "",
			mapFeature: null,
			markerArray: [],
			popupStreeViewActive: false,
			overlay: new GoogleMapsOverlay({layers: []}),
			infoWindow: new google.maps.InfoWindow(),
			iconLayer: null,
			bounceInterval: null,
			coordinates: [],
			options: {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0,
			},
		};
	},
	created() {
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
	},
	mounted() {
		document.addEventListener("click", (e) => {
			if (e.target.matches(".streetview-maps-module-optimization")) {
				this.openStreetView({
					cx: this.coordinates[0],
					cy: this.coordinates[1],
				});
			}
		});
	},
	methods: {
		success(pos) {
			const crd = pos.coords;
			const position = {cy: +crd.latitude, cx: +crd.longitude};
			this.map.setCenter({lat: position.cy, lng: position.cx});
		},
		showMarkersInMap() {
			if (this.visitPointList.length === 0) {
				this.initialize();
				return;
			}
			const payload = {data: this.visitPointList};
			this.loadAndDisplayMarkers(payload);
		},
		addSomeMarkers(visitPointArray) {
			if (visitPointArray.length === 0) {
				this.initialize();
				return;
			}
			const payload = {data: visitPointArray};
			this.loadAndDisplayMarkers(payload, this.visitPointList.length > 0 ? true : false);
		},
		loadAndDisplayMarkers(payload, mergeWithExisting = false) {
			this.$vs.loading();
			this.$store
				.dispatch("moduleMap/convertJsonToGeojson", payload)
				.then((res) => {
					this.$vs.loading.close();
					const geojson = res.data[0].geojson;
					if (mergeWithExisting && this.visitPointList.length > 0) {
						this.mergeNewMarkers(geojson);
					} else {
						this.displayNewMarkers(geojson);
					}
				})
				.catch((error) => {
					this.$vs.loading.close();
					console.error(error);
				});
		},
		mergeNewMarkers(geojson) {
			const newFeatures = geojson.features.filter(
				(item) =>
					!this.iconLayer.props.data.some(
						(point) => point.properties.identification === item.properties.identification
					)
			);
			const updatedData = this.iconLayer.props.data.concat(newFeatures);
			this.updateIconLayer(updatedData);
		},
		async displayNewMarkers(geojson) {
			// Asegúrate de que geojson sea un objeto válido
			if (!geojson || !geojson.features || geojson.features.length === 0) {
				console.warn("GeoJSON data is invalid or empty.");
				return;
			}
			this.iconLayer = await this.createIconLayer(geojson, true);
			this.overlay.setProps({layers: this.iconLayer});
			this.overlay.setMap(this.map);
			this.markerArray = geojson;
			setTimeout(
				async () => {
					this.mapFeature.fitboundGeoJson(geojson);
				},
				geojson.features.length > 6000 ? 6000 : 1000
			);
			this.$emit("markerArrayEmit", geojson);
		},
		updateIconLayer(updatedData) {
			this.iconLayer = new IconLayer({
				...this.iconLayer.props,
				data: updatedData,
			});
			this.overlay.setProps({layers: this.iconLayer});
			this.markerArray.features = updatedData;
			this.mapFeature.fitboundGeoJson(this.markerArray);
			this.$emit("markerArrayEmit", this.markerArray);
		},
		removeMarker(marker) {
			const updatedData = this.iconLayer.props.data.filter(
				(point) => point.properties.identification !== marker.properties.identification
			);
			this.updateIconLayer(updatedData);
			this.map.setZoom(6);
		},
		async initMap() {
			this.map = await new google.maps.Map(document.getElementById("map-optimization"), {
				center: {lat: this.latitude, lng: this.longitude},
				zoom: 8,
				styles: Uber,
			});
			google.maps.event.addListener(this.map, "click", (event) => {
				this.getCallbackClick(event);
			});
			if (this.changeCursorEnable) {
				this.changeCursor("crosshair");
			}
			this.mapFeature = new MapFeatures(this.map);
			this.overlay = new GoogleMapsOverlay({layers: []});
			this.showMarkersInMap();
		},

		/**
		 * change cursor options from different options
		 * * https://www.rubenalcaraz.es/pinakes/informatica/introduccion-google-maps-apiv3-mapoptions-y-el-contenedor-y-cursor/
		 * * https://itecnote.com/tecnote/google-maps-how-do-i-set-a-custom-image-for-the-mouse-cursor-in-a-google-map-api-v3-map/
		 */
		changeCursor(type = "pointer") {
			this.map.setOptions({draggableCursor: type});
		},
		initialize() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(this.success, this.error, this.options);
			}
		},
		error(err) {
			this.map.setCenter({lat: 4.686699, lng: -74.0837187});
			console.warn("ERROR(" + err.code + "): " + err.message);
		},
		createIconLayer(data, visibility) {
			return new IconLayer({
				id: `icon-layer-${this.typeService}`,
				data: data.hasOwnProperty("features") ? data.features : [],
				pickable: true,
				stroked: true,
				filled: true,
				visible: visibility,
				getIcon: () => ({
					url:
						this.typeService === "pickup"
							? Utils.addIconSvgWithMarker("420D91", "🚚")
							: Utils.addIconSvgWithMarker("FE7C00", "📦"),
					width: 40,
					height: 60,
				}),
				onClick: (info) => {
					if (info.object) {
						this.coordinates = info.object.geometry.coordinates;
						info.object.properties.infoWindow = this.infoWindow;
						const content = this.generateInfowindowContentVisitPoint(
							info.object.properties,
							this.infoWindow
						);
						this.infoWindow.setContent(content);
						this.infoWindow.setPosition(new google.maps.LatLng(this.coordinates[1], this.coordinates[0]));
						this.infoWindow.open(this.map);
					}
				},
				sizeScale: 1,
				getPosition: (d) => d.geometry.coordinates,
				getSize: (d) => 30,
				getIconSize: (d) => [40, 60],
			});
		},
		generateInfowindowContentVisitPoint({identification, latitude, longitude, time_service}, infowindow) {
			// Diseño del contenido html del infowindow
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			let $headerInfoWindowContent = document.createElement("div");
			$infowindowDivContent.style.cssText = "text-align: justify; position: relative"; // Añadido para posicionar el botón de cierre// Crear el botón de cierre
			$headerInfoWindowContent.className = "flex items-center justify-between";
			let $closeButton = document.createElement("button");
			$closeButton.textContent = "X";
			$closeButton.className = "bg-warning text-white rounded-full p-1 ml-2 cursor-pointer font-bold";
			$closeButton.addEventListener("click", () => {
				infowindow.close();
			});
			let $title = document.createElement("h5");
			$title.textContent = identification;
			let $identification = document.createElement("p");
			let $latitude = document.createElement("p");
			let $longitude = document.createElement("p");
			let $timeService = document.createElement("p");
			let $avatar = document.createElement("img");
			$avatar.setAttribute("src", streetviewImg);
			$avatar.setAttribute("alt", "StreetView");
			$avatar.setAttribute("title", "StreetView");
			$avatar.className = "h-8 w-8 mr-1 mt-2 cursor-pointer streetview-maps-module-optimization float-right";
			$identification.innerHTML = `<strong>${this.$t(
				"Routing.Table.Identification"
			)}:</strong> ${identification}`;
			$latitude.innerHTML = `<strong>${this.$t("Deposits.Form.Latitude")}</strong>: ${latitude}`;
			$latitude.className = "mt-1";
			$longitude.innerHTML = `<strong>${this.$t("Deposits.Form.Longitude")}</strong>: ${longitude}`;
			$longitude.className = "mt-1 mb-1";
			$timeService.innerHTML = `<strong>${this.$t("Routing.Table.TimeService")}</strong>: ${
				time_service ? time_service : "00:00:00"
			}`;
			$docFragment.appendChild($latitude);
			$docFragment.appendChild($longitude);
			$docFragment.appendChild($timeService);
			$docFragment.appendChild($avatar);
			$headerInfoWindowContent.appendChild($title);
			$headerInfoWindowContent.appendChild($closeButton);
			$infowindowDivContent.appendChild($headerInfoWindowContent);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
		openStreetView({cy, cx}) {
			Anuket.streetView({lat: parseFloat(cy), lng: parseFloat(cx)}, {container: "#gpanoramaoptimization"});
			this.popupStreeViewActive = true;
		},
		startBounceAnimation(id) {
			const bounceHeight = 0.0025; // Altura del rebote (en grados)
			const bounceSpeed = 150; // Velocidad de la animación (en ms)
			let bounceUp = true;
			this.bounceInterval = setInterval(() => {
				// Actualizar la posición del punto
				this.markerArray.features = this.markerArray.features.map((d) => {
					if (d.properties.identification === id) {
						d.geometry.coordinates[1] += bounceUp ? bounceHeight : -bounceHeight;
						return d;
					}
					return d;
				});
				bounceUp = !bounceUp;
				// Actualizar la capa IconLayer con los nuevos datos
				const updatedIconLayer = new IconLayer({
					...this.iconLayer.props,
					data: this.markerArray.features,
				});
				this.overlay.setProps({
					layers: updatedIconLayer,
				});
			}, bounceSpeed);
		},
		closeAnimation(id) {
			clearInterval(this.bounceInterval);
			this.resetIconPosition(id);
			this.map.setZoom(6);
		},
		resetIconPosition(id) {
			// Restablecer la posición del ícono a su valor original
			this.markerArray.features = this.markerArray.features.map((d) => {
				if (d.properties.identification === id) {
					d.geometry.coordinates[1] = d.properties.latitude;
					return d;
				}
				return d;
			});
			const updatedIconLayer = new IconLayer({
				...this.iconLayer.props,
				data: this.markerArray.features,
			});
			this.overlay.setProps({
				layers: updatedIconLayer,
			});
		},
	},
	beforeDestroy() {
		this.overlay = new GoogleMapsOverlay({layers: []});
	},
};
</script>

<style scoped>
/** custom content for map */
.map-custom-container {
	margin-top: calc(100% - 102%);
	height: 95vh;
}

.street-vien-container-optimization {
	width: 100%;
	height: 40vh;
}

.customizer-btn-map-opc {
	position: fixed;
	top: 50%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.customizer-btn-map-clear {
	position: fixed;
	top: 45%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition {
	position: fixed;
	top: 69px;
	left: 100px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-custom-container-calendar {
	height: 560px !important;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}

	.street-vien-container-optimization {
		width: 100%;
		height: 60vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}

	.street-vien-container-optimization {
		width: 100%;
		height: 40vh;
	}

	.map-top-left-possition {
		position: fixed;
		top: 69px;
		left: 10px;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		z-index: 50000;
	}
}
</style>
<style lang="scss">
#map-optimization {
	/* Hide the default close button of the InfoWindow */
	.gm-ui-hover-effect {
		display: none !important;
	}
	.custom-info-window {
		padding: 10px;
		background-color: white;
		border: 1px solid #ccc;
		border-radius: 4px;
	}
}
</style>
